import React from 'react';

// src/utils/preloadRoute.js
export const routeComponents: Record<string, any> = {};

export const preloadRoute = (componentName: string, importFn: any) => {
  if (!routeComponents[componentName]) {
    routeComponents[componentName] = {
      promise: importFn().then((module: any) => {
        routeComponents[componentName].component = module.default;
        return module;
      }),
      component: null,
    };
  }
  return routeComponents[componentName].promise;
};

export const lazyWithPreload = (componentName: string, importFn: any) => {
  const LazyComponent: any = React.lazy(() => importFn());

  // 添加预加载方法
  LazyComponent.preload = () => preloadRoute(componentName, importFn);

  return LazyComponent;
};
